import React, { useState } from 'react';
import { Logo } from './Logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-regular-svg-icons';
import styles from './Header.module.scss';
import UserAvatar from './UserAvatar';

interface HeaderProps {
    onMenuToggle: () => void;
    isMobile: boolean;
    className?: string;
}

export const Header: React.FC<HeaderProps> = ({ 
    onMenuToggle, 
    isMobile, 
    className 
}) => {
    return (
        <header className={`${styles.header} ${className || ''}`}>
            <div className={styles.leftSection}>
                {isMobile && (
                    <button 
                        className={styles.menuToggle}
                        onClick={onMenuToggle}
                        aria-label="Toggle menu"
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                )}
                <Logo className={styles.logo} />
            </div>

            <div className={styles.rightSection}>
                <UserAvatar />
            </div>
        </header>
    );
};

export default Header;
